import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";
import { PARTNER_ROOM_FILTER_ALL } from "@/components/pages/guesteria-partners/components/PartnerOrdersTable";

/**
 * Task 0041 sim fix (2026-09-30): the orders-table room filter is now
 * persisted in the URL query, the same way the shared period is —
 * shareable, survives reload. `paramName` lets a page host more than one
 * orders table if it ever needs to.
 */
export function useOrdersRoomFilter(paramName = "orderRoom") {
  const [searchParams, setSearchParams] = useSearchParams();
  const roomFilter = searchParams.get(paramName) || PARTNER_ROOM_FILTER_ALL;

  const setRoomFilter = useCallback(
    (value: string) => {
      setSearchParams(
        (prev) => {
          const next = new URLSearchParams(prev);
          if (value === PARTNER_ROOM_FILTER_ALL) {
            next.delete(paramName);
          } else {
            next.set(paramName, value);
          }
          return next;
        },
        { replace: true },
      );
    },
    [paramName, setSearchParams],
  );

  return [roomFilter, setRoomFilter] as const;
}
